import React from 'react';
import { useContent } from '../i18n/LanguageContext';
import { Check, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export default function Pricing({ onSelect }) {
  const c = useContent();
  const pr = c.pricing;
  return (
    <section id="tarifs" className="py-14 md:py-20 bg-slate-50">
      <div className="lt-container">
        <div className="max-w-3xl mx-auto text-center reveal">
          <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{pr.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{pr.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{pr.subtitle}</p>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-6 items-stretch">
          {pr.plans.map((p, i) => (
            <div key={p.name} className={`reveal relative rounded-3xl p-8 flex flex-col ${
              p.highlighted ? 'bg-slate-900 text-white border border-slate-900 shadow-2xl lg:-mt-4 lg:mb-4' : 'bg-white text-slate-900 border border-slate-200'
            }`} style={{ animationDelay: `${i * 90}ms` }}>
              {p.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-teal-500 text-slate-900 text-xs font-bold px-3.5 py-1.5">
                  <Sparkles className="w-3.5 h-3.5" /> {pr.badge}
                </span>
              )}
              <h3 className="font-display text-xl font-bold">{p.name}</h3>
              <p className={`mt-2 text-sm ${p.highlighted ? 'text-slate-300' : 'text-slate-500'}`}>{p.desc}</p>

              <div className="mt-6 flex items-end gap-1">
                <span className="font-display text-3xl font-bold">{pr.custom}</span>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((ft) => (
                  <li key={ft} className="flex items-start gap-3 text-sm">
                    <span className={`mt-0.5 grid place-items-center w-5 h-5 shrink-0 rounded-full ${p.highlighted ? 'bg-teal-500/20 text-teal-300' : 'bg-teal-50 text-teal-600'}`}>
                      <Check className="w-3.5 h-3.5" />
                    </span>
                    <span className={p.highlighted ? 'text-slate-200' : 'text-slate-600'}>{ft}</span>
                  </li>
                ))}
              </ul>

              <Button onClick={onSelect} className={`btn-shine mt-8 h-12 rounded-full font-semibold ${
                p.highlighted ? 'bg-teal-500 hover:bg-teal-400 text-slate-900' : 'bg-slate-900 hover:bg-slate-800 text-white'
              }`}>
                {c.cta.quote}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
